import { forkJoin, type Observable, of } from 'rxjs';

export function forkJoinWithMapper<T, R>(
  items: T[],
  mapper: (item: T) => Observable<R>,
): Observable<R[]> {
  if (items.length === 0) {
    return of([]);
  }
  return forkJoin(items.map(item => mapper(item)));
}
